import React, { useState, useEffect } from "react";

function SearchInput({ searchQuery, setSearchQuery, placeholder, data, onSearchResults, className, allData }) {
  const [filteredData, setFilteredData] = useState(data || []);

  useEffect(() => {
    if (searchQuery.length >= 3) {
      const results = allData?.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(results);

      // Only call onSearchResults if the filtered data is different
      if (JSON.stringify(results) !== JSON.stringify(filteredData)) {
        onSearchResults(results);
      }
    } else {
      setFilteredData(data);

      // Prevent infinite loop by checking if the data has changed
      if (JSON.stringify(data) !== JSON.stringify(filteredData)) {
        onSearchResults(data);
      }
    }
  }, [searchQuery, data, allData]); // Removed `onSearchResults` from dependencies

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className={`mb-4 min-w-[20%] ${className}`}>
      <input
        type="text"
        placeholder={placeholder || "Search..."}
        className="w-full p-1 border rounded"
        value={searchQuery}
        onChange={handleSearchChange}
      />
    </div>
  );
}

export default SearchInput;
